// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Radio
} from '@arco-design/web-react';
import { post, get, put, del as deleteRequest } from '../requestNew';
import { baseUrl } from '../utils';
import dayjs from 'dayjs';

import './index.scss';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

interface UmsAdmin {
  id?: number;
  username: string;
  password?: string;
  icon?: string;
  email: string;
  nickName: string;
  note?: string;
  createTime?: string;
  loginTime?: string;
  status: number;
}

function AdminManagement() {
  const [form] = Form.useForm<UmsAdmin>();
  const [formSearch] = Form.useForm();
  const [roleForm] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [roleModalVisible, setRoleModalVisible] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<UmsAdmin[]>([]);
  const [loading, setLoading] = useState(false);
  const [roleList, setRoleList] = useState<any[]>([]);
  const [currentAdminId, setCurrentAdminId] = useState<number | null>(null);
  const formRef = useRef<any>({});

  // 获取数据列表
  const getList = (reset?: boolean) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(10);
    }

    const searchValues = formSearch.getFieldsValue();
    const params = {
      keyword: searchValues.keyword || '',
      pageNum: reset ? 1 : pageNum,
      pageSize: reset ? 10 : pageSize
    };

    get('/admin/list', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total: totalCount } = data || {};
          setTotal(totalCount || 0);
          setDataList(list || []);
        } else {
          Message.error(message || '获取数据失败!');
        }
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 获取所有角色列表
  const getAllRoles = () => {
    get('/role/listAll')
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          setRoleList(data || []);
        }
      })
      .catch(() => {
        Message.error('获取角色列表失败!');
      });
  };

  // 获取用户角色
  const getUserRoles = (adminId: number) => {
    get(`/admin/role/${adminId}`)
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          const roleIds = (data || []).map((role: any) => role.id);
          roleForm.setFieldsValue({ roleIds });
        }
      })
      .catch(() => {
        Message.error('获取用户角色失败!');
      });
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: '编号',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '账户名',
      dataIndex: 'username',
      width: 120
    },
    {
      title: '姓名',
      dataIndex: 'nickName',
      width: 120
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      width: 180
    },
    {
      title: '添加时间',
      dataIndex: 'createTime',
      width: 180,
      render: text => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-')
    },
    {
      title: '最后登录',
      dataIndex: 'loginTime',
      width: 180,
      render: text => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-')
    },
    {
      title: '是否启用',
      dataIndex: 'status',
      width: 100,
      render: (text, record) => <Switch checked={text === 1} onChange={val => handleStatusChange(val, record)} />
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 200,
      render: (_, record: UmsAdmin) => (
        <Space>
          <Button type="text" onClick={() => handleAssignRole(record)} loading={loading}>
            分配角色
          </Button>
          <Button type="text" onClick={() => edit(record)} loading={loading}>
            编辑
          </Button>
          <Popconfirm focusLock title="提示" content="是否要删除该用户?" onOk={() => del(record)}>
            <Button type="text" status="danger" loading={loading}>
              删除
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  // 处理状态变更
  const handleStatusChange = (val: boolean, record: UmsAdmin) => {
    if (!record.id) {
      Message.error('用户ID不存在！');
      return;
    }
    setLoading(true);
    const status = val ? 1 : 0;
    get(`/admin/updateStatus/${record.id}`, { status })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(10);
    getList(true);
  };

  // 新增用户
  const add = () => {
    formRef.current = {};
    form.resetFields();
    form.setFieldsValue({
      status: 1
    });
    setVisible(true);
  };

  // 删除用户
  const del = (record: UmsAdmin) => {
    if (!record.id) {
      Message.error('用户ID不存在！');
      return;
    }
    setLoading(true);

    post(`/admin/delete/${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑用户
  const edit = (record: UmsAdmin) => {
    formRef.current = record;
    form.setFieldsValue({
      ...record,
      password: '' // 编辑时不显示密码
    });
    setVisible(true);
  };

  // 分配角色
  const handleAssignRole = (record: UmsAdmin) => {
    if (!record.id) {
      Message.error('用户ID不存在！');
      return;
    }
    setCurrentAdminId(record.id);
    getAllRoles();
    getUserRoles(record.id);
    setRoleModalVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 取消分配角色
  const roleModalCancel = () => {
    setRoleModalVisible(false);
    setCurrentAdminId(null);
    roleForm.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form
      .validate()
      .then(values => {
        setLoading(true);
        const data: any = {
          ...formRef.current,
          ...values
        };

        // 如果是新增，密码是必填的
        if (!formRef.current.id && !values.password) {
          Message.error('请输入密码');
          setLoading(false);
          return;
        }

        // 编辑时，如果密码为空，则不传密码字段
        if (formRef.current.id && !values.password) {
          delete data.password;
        }

        if (formRef.current.id) {
          // 更新用户
          post(`/admin/update/${formRef.current.id}`, data)
            .then((res: any) => {
              const { code, message } = res || {};
              if (code === 200) {
                Message.success('编辑成功！');
                getList();
                editCancel();
              } else {
                Message.error(message);
              }
            })
            .catch(e => {
              Message.error('网络错误!');
              console.log(e);
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          // 创建用户
          post(`/admin/register`, data)
            .then((res: any) => {
              const { code, message } = res || {};
              if (code === 200) {
                Message.success('新增成功！');
                getList();
                editCancel();
              } else {
                Message.error(message);
              }
            })
            .catch(e => {
              Message.error('网络错误!');
              console.log(e);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      })
      .catch(() => {
        Message.error('请检查表单填写是否正确!');
      });
  };

  // 提交角色分配
  const onRoleOk = () => {
    roleForm
      .validate()
      .then(values => {
        if (!currentAdminId) {
          Message.error('用户ID不存在！');
          return;
        }
        setLoading(true);
        const { roleIds } = values;
        const params: any = {
          adminId: currentAdminId,
          roleIds: roleIds || []
        };

        post(`/admin/role/update`, params)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('分配角色成功！');
              roleModalCancel();
              getList();
            } else {
              Message.error(message);
            }
          })
          .catch((e: any) => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        Message.error('请检查表单填写是否正确!');
      });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="admin-management table-flex">
      <div className="filter-section">
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="搜索:" field="keyword">
            <Input style={{ width: 200 }} placeholder="账号或姓名" allowClear />
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <Button type="primary" onClick={add} loading={loading}>
            添加
          </Button>
        </Form>
      </div>
      <Table
        rowKey="id"
        columns={columns}
        data={dataList}
        className="table-scroll"
        pagination={{
          sizeCanChange: true,
          pageSize,
          total,
          showTotal: true,
          current: pageNum,
          onChange: (num, size) => {
            setPageNum(num);
            if (size && size !== pageSize) {
              setPageSize(size);
            }
          }
        }}
        scroll={{ y: '100%', x: '100%' }}
        loading={loading}
      />

      {/* 新增/编辑用户弹框 */}
      <Modal
        title={formRef.current.id ? '编辑用户' : '添加用户'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
        autoComplete="off"
        autoFocus={false}
        focusLock={false}
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="账户名:" field="username" rules={[{ required: true, message: '请输入账户名' }]}>
            <Input placeholder="请输入..." autoComplete="off" autoComplete="new-password" />
          </FormItem>
          <FormItem label="姓名:" field="nickName" rules={[{ required: true, message: '请输入姓名' }]}>
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem
            label="邮箱:"
            field="email"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '请输入正确的邮箱格式' }
            ]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem
            label="密码:"
            field="password"
            rules={!formRef.current.id ? [{ required: true, message: '请输入密码' }] : []}
          >
            <Input.Password placeholder={formRef.current.id ? '留空则不修改密码' : '请输入密码'} />
          </FormItem>
          <FormItem label="备注:" field="note">
            <Input.TextArea placeholder="请输入..." rows={3} />
          </FormItem>
          <FormItem label="是否启用:" field="status" triggerPropName="value">
            <Radio.Group>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </FormItem>
        </Form>
      </Modal>

      {/* 分配角色弹框 */}
      <Modal
        title="分配角色"
        visible={roleModalVisible}
        onCancel={roleModalCancel}
        onOk={onRoleOk}
        unmountOnExit
        style={{ width: 500 }}
        confirmLoading={loading}
      >
        <Form form={roleForm}>
          <FormItem label="角色:" field="roleIds" rules={[{ required: false }]}>
            <Select mode="multiple" placeholder="请选择角色" allowClear>
              {roleList.map(role => (
                <Option key={role.id} value={role.id}>
                  {role.name}
                </Option>
              ))}
            </Select>
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default AdminManagement;
